import { h } from 'preact';
import * as BaseComp from 'components/bolt/home/home.js';
import { accessNested, joinClasses } from 'utils/utils';
import Gallery from 'components/bolt/gallery/gallery';
import s from 'components/bolt/home/home.sss';
import Store from 'store/store';

export default class Home extends BaseComp.default {
	renderExtraStuff() {
		const { appData, client } = this.props;
		const miniGallery = accessNested(appData, 'options.paramountFeatures.toutCarousel', false);

		if (!miniGallery || !client.isDesktopSize) {
			return;
		}
		
		const homeActivePercentage = accessNested(Store.get(), 'homeActivePercentage', 1);
		const homeScrolledALittleBit = homeActivePercentage <= .8;

		return (
			<div key="mini-gallery-desktop" class={joinClasses(s.miniGallery, homeScrolledALittleBit && s.fade)}>
				<Gallery appData={appData} client={client} isMiniGallery />
			</div>
		);
	}

	renderExtraTopSection() {
		const { appData, client } = this.props;
		const miniGallery = accessNested(appData, 'options.paramountFeatures.toutCarousel', false);

		if (!miniGallery || client.isDesktopSize) {
			return;
		}

		return (
			<div key="mini-gallery-mobile" class={s.miniGallery}>
				<Gallery appData={appData} client={client} isMiniGallery />
			</div>
		);
	}
}